import { ReactNode } from 'react';
import { toast } from 'react-toastify';

const error = (message: string | ReactNode) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export default error;
